import * as React from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { Tabs } from '@independent-software/typeui/controls/Tabs';
import { ToastService } from '@independent-software/typeui/controls/Toast';
import { Markdown } from '@independent-software/typeui/formatters/Markdown';
import { Flex } from '@independent-software/typeui/controls/Flex';
import { Header } from '@independent-software/typeui/controls/Header';
import { Label } from '@independent-software/typeui/controls/Label';

import { AuthContext } from '../../AuthContext';
import { FilterContext } from '../../FilterContext';
import { Section, Viewer } from '../../modules';
import { Project, ProjectFactory, Campaign } from '../../resource/'; 
import { ListCampaigns } from '../Campaign';
import { Output } from '../../controls/Output';

const ViewProject = () => {
  const auth = React.useContext(AuthContext);
  const filter = React.useContext(FilterContext);
  const navigate =  useNavigate();
  const { id } = useParams();
  
  const handleEdit = () => {
    navigate(`/projects/edit/${parseInt(id)}`);
  }

  const handleDelete = () => {
    ToastService.toast("Project deleted.");
    navigate('/projects');
  }    

  const handleCampaignClick = (item:Campaign) => {
    navigate(`/campaigns/${item.id}`);
  }    

  return (
    <Viewer<Project> 
      auth={auth}
      id={parseInt(id)}
      factory={ProjectFactory}
      canEdit='can_edit_projects'
      canDelete='can_delete_projects'
      onEdit={handleEdit}
      onDelete={handleDelete}
      content={(project: Project) => 
        <>
          <Section dark padded>
            <Header size="h2">{project.name}</Header>
          </Section>
          <Tabs underlined>
            <Tabs.Pane label="Data">
              <Section padded="very">
                <Flex.Columns count={2}>
                  <>
                    <Output label="Name" hint="Project name">{project.name}</Output>
                    <Output label="Reference" hint="Project reference">{project.reference}</Output>
                    <Output label="Agency" hint="Funding agency">{project.agency}</Output>
                    <Output label="Manager" hint="Data manager">{project.manager}</Output>
                    <Output label="Contact" hint="Contact information">{project.contact}</Output>
                  </>
                  <Output label="Description" hint="Project description"><Markdown source={project.description}/></Output>
                </Flex.Columns>
              </Section>
            </Tabs.Pane>
            <Tabs.Pane label={<span>Campaigns <Label size="small">{project.campaigns_count}</Label></span>}>
              <ListCampaigns auth={auth} filter={filter} name="projects_campaigns" projectId={project.id} onClick={handleCampaignClick}/>
            </Tabs.Pane>                  
          </Tabs>
        </>}>
    </Viewer>
  );
}

export { ViewProject }
